export class User{
	userId: string;
	firstName: string;
	middleName: string;
	lastName: string;
	email: string;
	telephone: string;
	organization: string;
	roleId: string;
	role:string;
	validFrom: Date;
	validTo: Date;
	status: string;
}
